<template>
<div>
<div class="box" style="text-align:center;" v-show='!isScan'>
  <div  style="margin:40px 20px;"><img src="@/assets/image/扫码.jpeg" alt="" width="200" height="200"></div>
  <van-button type="danger" style="width:230px;" @click="onScanClick">立即扫码</van-button>
</div>
<div class="box" v-show='isScan'>
<!-- <QrCode @onDecode='onDecode'/> -->
<!-- <Browser @getScanResult='onDecode'/> -->
</div>
</div>
</template>

<script>
// import QrCode from "@/components/QrCode";
// import Browser from "@/components/Browser";
// import { getJsapiTicket } from "@/api/common"

import wx from 'weixin-js-sdk'
export default {
  name: 'qrReporting',
  components: {
    // QrCode,
    // Browser
  },
  data() {
    return {
      isScan:false,
      data: {value:'',type:'FHL'},
      numberKeyboard:'HEIGHT',
      result:''
    };
  },
  mounted() {
  
  },
  methods: {
    onScanClick(){
      // let url= location.href
      // getJsapiTicket({url:url}).then(r=>{
      //   console.log(r);
      //   wx.config({
      //     debug: false, // 开启调试模式,
      //     appId: r.data.body.app_id, // 必填，企业号的唯一标识，此处填写企业号corpid
      //     timestamp: r.data.body.time_millis, // 必填，生成签名的时间戳
      //     nonceStr: r.data.body.noncestr, // 必填，生成签名的随机串
      //     signature: r.data.body.signature,// 必填，签名，见附录1
      //     // jsapi_ticket:jsapi_ticket,
      //     jsApiList: ['checkJsApi', 'getLocation','openLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      //   });
      // })
      //  wx.config({
      //     debug: false, // 开启调试模式,
      //     appId: r.result.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
      //     timestamp: r.result.timestamp, // 必填，生成签名的时间戳
      //     nonceStr: r.result.nonceStr, // 必填，生成签名的随机串
      //     signature: r.result.signature, // 必填，签名，见附录1
      //     // jsapi_ticket:jsapi_ticket,
      //     jsApiList: ["checkJsApi", "getLocation", "openLocation"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      //   });
  let that = this    
  wx.scanQRCode({
  needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
  scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
  success: function (res) {
    var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
    let stringList =  result.split('&&')
    if (stringList.length!==2) {
      that.$notify({ type: "danger", message: '请扫描本系统孩子二维码！' });
      return
    }
    that.$router.push({path:'teacherReporting/reportingList',query:{snCode:stringList[0],schoolCode:stringList[1]}})
  },
  error:function(res){
        alert(res)
  }
})
// this.isScan = true
    },
    onDecode(val){
console.log(val);
let stringList =  val.split('&&')
   this.$router.push({path:'teacherReporting/reportingList',query:{snCode:stringList[0],schoolCode:stringList[1]}})

if (this.$route.query.pageType=='SGTZ') {
  // 身高体重
   this.$router.push({path:'heightWeightMgt',query:{code:val}})
}else if(this.$route.query.pageType=='FHL'){
  // 肺活量
   this.$router.push({path:'vitalCapacityMgt',query:{code:val}})
}else if(this.$route.query.pageType=='ZWTQQ'){
  // 坐位体前屈
   this.$router.push({path:'ZWTQQMgt',query:{code:val}})
}else if(this.$route.query.pageType=='LDTY'){
  // lidingtiaoyuan 立定跳远
   this.$router.push({path:'LDTYMgt',query:{code:val}})
}else if(this.$route.query.pageType=='YTXX'){
  // lidingtiaoyuan 引体向上
   this.$router.push({path:'YTXXMgt',query:{code:val}})
}else if(this.$route.query.pageType=='YWQZ'){
  // lidingtiaoyuan 仰卧起坐
   this.$router.push({path:'YWQZMgt',query:{code:val}})
}

    },
clickRight(){
  //  { label: '肺活量', value: 'FHL' },
if (this.data.value=='') {this.$toast.fail('请输入！'); return}
// if (this.data.weight=='') {this.$toast.fail('请输入体重！');return}
let Data = {...this.data,name:'yangsen',code:this.$route.query.code}
    this.$dialog.confirm({
        message: '确定提交?',
    }).then(()=>{
    setPersistenceData(Data)
    // this.$store.commit('SER_SUBMIT_DATA',JSON.stringify(this.data))
    })

},    


onInput(val){

    // this.data.height +=val
},
onDelete(val){
    if (!this.data.height) {
        return
    }
},
  },
};
</script>

<style lang="less" scoped>
.box{
}



</style>
